var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6253 0.5H15.8675C15.748 0.5 15.6355 0.558594 15.5651 0.654688L8.90655 9.83281L2.24795 0.654688C2.17764 0.558594 2.06514 0.5 1.94561 0.5H0.187797C0.0354531 0.5 -0.0536094 0.673438 0.0354531 0.797657L8.29952 12.1906C8.59952 12.6031 9.21358 12.6031 9.51124 12.1906L17.7753 0.797657C17.8667 0.673438 17.7776 0.5 17.6253 0.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.96e0c4065f3a3aa9e56a612ab118e6f9.svg";
export { ForwardRef as ReactComponent };